import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { GapStylingConfig } from './gap-styling';

export class GapStylingService {
  private static readonly COLLECTION = 'app-configurations';
  private static readonly DOCUMENT = 'display-content-config';
  private static readonly FIELD = 'raffle-gaps';

  /**
   * Load gap styling configuration from Firebase
   */
  static async loadConfig(): Promise<GapStylingConfig | null> {
    try {
      const docRef = doc(db, this.COLLECTION, this.DOCUMENT);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        const data = docSnap.data();
        return data?.[this.FIELD] || null;
      }
      
      return null;
    } catch (error) {
      console.error('Error loading gap styling configuration:', error);
      throw new Error('Failed to load gap styling configuration');
    }
  }

  /**
   * Save gap styling configuration to Firebase
   */
  static async saveConfig(config: GapStylingConfig): Promise<void> {
    try {
      const docRef = doc(db, this.COLLECTION, this.DOCUMENT);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        // Document exists, update it
        await updateDoc(docRef, {
          [this.FIELD]: config
        });
      } else {
        // Document doesn't exist, create it
        await setDoc(docRef, {
          [this.FIELD]: config
        });
      }
    } catch (error) {
      console.error('Error saving gap styling configuration:', error);
      throw new Error('Failed to save gap styling configuration');
    }
  }

  /**
   * Reset gap styling configuration (remove from Firebase)
   */
  static async resetConfig(): Promise<void> {
    try {
      const docRef = doc(db, this.COLLECTION, this.DOCUMENT);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        await updateDoc(docRef, {
          [this.FIELD]: null
        });
      }
    } catch (error) {
      console.error('Error resetting gap styling configuration:', error);
      throw new Error('Failed to reset gap styling configuration');
    }
  }
}